pointman.define("m/sufei-zepto_config", function () {
	return {
		app: "h5-zepto",
		version: "1.0.1",
		style: "//g.alicdn.com/sd/pointman/app/common/sufei-h5.css"
	}
});
